query simpleTennisTeams($search: String) {
  teams: allTennisTeams(
    orderBy: NAME_ASC
    first: 20
    filter: { name: { includesInsensitive: $search } }
  ) {
    nodes {
      id: teamId
      name
    }
  }
}
